// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NovoAqui.module.css */
.NovoAqui_overlay__uHCnS {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #1e1e1ed7;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.NovoAqui_popup__QzT8T {
    background-color: #1e1e1e;
    width: 90%;
    max-width: 500px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    overflow: hidden;
    position: relative;
}

.NovoAqui_closeButton__WTOqW {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #ffffff;
}

.NovoAqui_imageSection__Fcqnx img {
    width: 100%;
    height: auto;
}

.NovoAqui_content__KYcrU {
    padding: 20px;
    text-align: center;
}

.NovoAqui_subtitle__acAyw {
    font-family: "Space Grotesk", sans-serif;
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    font-size: 1.5rem;
    color: #ffffff;
    margin-bottom: 15px;
}

.NovoAqui_description__OhlmW {
    font-size: 1rem;
    color: #ffffff;
    margin-bottom: 15px;
}

.NovoAqui_formGroup__mPQ9c {
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.NovoAqui_formGroup__mPQ9c label {
    font-size: 0.9rem;
    color: #ffffff;
    margin-bottom: 5px;
}

.NovoAqui_formGroup__mPQ9c input,
.NovoAqui_formGroup__mPQ9c textarea {
    width: 100%;
    max-width: 400px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 1rem;
    color: #000000;
}

.NovoAqui_formGroupCheckbox__b9Ur4 {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    color: #ffffff;
    margin-top: 10px;
}

.NovoAqui_formGroupCheckbox__b9Ur4 label {
    text-align: left;
}

.NovoAqui_buttonContainer__UvsoI {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 20px;
}

.NovoAqui_prevButton__wjp7s,
.NovoAqui_nextButton__QRRQy,
.NovoAqui_submitButton__ZVyWf {
    background-color: #007bff;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s;
}

.NovoAqui_nextButton__QRRQy:hover,
.NovoAqui_prevButton__wjp7s:hover,
.NovoAqui_submitButton__ZVyWf:hover {
    background-color: #0056b3;
}

.NovoAqui_error__t33Qg {
    color: #ff0000;
    font-size: 0.8rem;
    margin-top: 5px;
}

.NovoAqui_errorInput__eDG-g {
    border-color: #ff0000;
}`, "",{"version":3,"sources":["webpack://./src/pages/Site/NovoAqui/NovoAqui.module.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;;;IAGI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["/* NovoAqui.module.css */\r\n.overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: #1e1e1ed7;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n}\r\n\r\n.popup {\r\n    background-color: #1e1e1e;\r\n    width: 90%;\r\n    max-width: 500px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\r\n    overflow: hidden;\r\n    position: relative;\r\n}\r\n\r\n.closeButton {\r\n    position: absolute;\r\n    top: 16px;\r\n    right: 16px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.5rem;\r\n    cursor: pointer;\r\n    color: #ffffff;\r\n}\r\n\r\n.imageSection img {\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.content {\r\n    padding: 20px;\r\n    text-align: center;\r\n}\r\n\r\n.subtitle {\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-optical-sizing: auto;\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    font-size: 1.5rem;\r\n    color: #ffffff;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.description {\r\n    font-size: 1rem;\r\n    color: #ffffff;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.formGroup {\r\n    margin-bottom: 15px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.formGroup label {\r\n    font-size: 0.9rem;\r\n    color: #ffffff;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.formGroup input,\r\n.formGroup textarea {\r\n    width: 100%;\r\n    max-width: 400px;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    font-size: 1rem;\r\n    color: #000000;\r\n}\r\n\r\n.formGroupCheckbox {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 0.9rem;\r\n    color: #ffffff;\r\n    margin-top: 10px;\r\n}\r\n\r\n.formGroupCheckbox label {\r\n    text-align: left;\r\n}\r\n\r\n.buttonContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.prevButton,\r\n.nextButton,\r\n.submitButton {\r\n    background-color: #007bff;\r\n    color: #fff;\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n}\r\n\r\n.nextButton:hover,\r\n.prevButton:hover,\r\n.submitButton:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n.error {\r\n    color: #ff0000;\r\n    font-size: 0.8rem;\r\n    margin-top: 5px;\r\n}\r\n\r\n.errorInput {\r\n    border-color: #ff0000;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `NovoAqui_overlay__uHCnS`,
	"popup": `NovoAqui_popup__QzT8T`,
	"closeButton": `NovoAqui_closeButton__WTOqW`,
	"imageSection": `NovoAqui_imageSection__Fcqnx`,
	"content": `NovoAqui_content__KYcrU`,
	"subtitle": `NovoAqui_subtitle__acAyw`,
	"description": `NovoAqui_description__OhlmW`,
	"formGroup": `NovoAqui_formGroup__mPQ9c`,
	"formGroupCheckbox": `NovoAqui_formGroupCheckbox__b9Ur4`,
	"buttonContainer": `NovoAqui_buttonContainer__UvsoI`,
	"prevButton": `NovoAqui_prevButton__wjp7s`,
	"nextButton": `NovoAqui_nextButton__QRRQy`,
	"submitButton": `NovoAqui_submitButton__ZVyWf`,
	"error": `NovoAqui_error__t33Qg`,
	"errorInput": `NovoAqui_errorInput__eDG-g`
};
export default ___CSS_LOADER_EXPORT___;
